import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { mapGetters, mapActions } from 'vuex';
import { FAST_TIMER } from '~/const/timers';
import registerStoreModule from '~/helpers/store-helper';
import configurator from '~/store/modules/configurator';
import TcVars from '~/components/functional/TcVars/ConfiguratorTcVars.vue';

var MdmLoader = function MdmLoader() {
  return import('~/components/atoms/Global/MdmLoader.vue');
};

var ConfiguratorSummary = function ConfiguratorSummary() {
  return import('~/components/organisms/Configurator/ConfiguratorSummary.vue');
};

var ConfiguratorControlPanel = function ConfiguratorControlPanel() {
  return import('~/components/organisms/Configurator/ConfiguratorControlPanel.vue');
};

var OpenGraph = function OpenGraph() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/functional/OpenGraph/ProductOpenGraph.vue');
};

export default {
  layout: 'blank',
  components: {
    TcVars: TcVars,
    MdmLoader: MdmLoader,
    ConfiguratorSummary: ConfiguratorSummary,
    ConfiguratorControlPanel: ConfiguratorControlPanel,
    OpenGraph: OpenGraph
  },
  data: function data() {
    return {
      customizableWatcher: false
    };
  },
  validate: function validate(_ref) {
    var params = _ref.params;
    return params.model;
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    options: 'configurator/options',
    information: 'configurator/information',
    encodedCustomizable: 'configurator/encodedCustomizable',
    customizable: 'configurator/customizable',
    selectedOption: 'configurator/selectedOption',
    configurator: 'configurator/configurator',
    price: 'configurator/price',
    baseURL: 'request/baseURL'
  }), {
    openGraphImage: function openGraphImage() {
      return "https://medias.maisonsdumonde.com/q_auto/w_375,dpr_1.3/canape-so-me/".concat(this.$route.params.model, "-C-1.png");
    },
    currentPath: function currentPath() {
      return "".concat(this.baseURL).concat(this.$route.path);
    }
  }),
  created: function created() {
    registerStoreModule(this.$store, 'configurator', configurator);

    if (process.client) {
      this.fetchConfigurator({
        model: this.$route.params.model
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.customizableWatcher = this.$watch('encodedCustomizable', debounce(function (model, oldModel) {
      if (oldModel) {
        var params = _this.$route.params;
        window.history.replaceState('', '', "/".concat(params.market, "/").concat(params.language, "/configurator/").concat(model));

        _this.fetchConfigurator({
          model: model
        });
      }
    }, FAST_TIMER));
  },
  destroyed: function destroyed() {
    this.customizableWatcher();
    this.$store.unregisterModule('configurator');
  },
  methods: _objectSpread({}, mapActions({
    fetchConfigurator: 'configurator/fetchConfigurator'
  })),
  head: function head() {
    return {
      title: 'So…me | Maisons du Monde',
      meta: [{
        charset: 'utf-8'
      }, {
        name: 'robots',
        content: 'noindex, nofollow'
      }]
    };
  }
};